import { makeStyles } from '@material-ui/core/styles';

export const useBulkFormFieldGridStyles = makeStyles(() => ({
  root: {
    minHeight: ({ shouldShowField }) => (shouldShowField ? 60 : 'auto')
  }
}));
